import { combineReducers } from 'redux'
import fruits from './fruits'

export default combineReducers({
  fruits
})